import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { useParallax } from "../hooks/useParallax";
import { RouteSeo } from "./RouteSeo";

const navigation = [
  ["/play", "Play"],
  ["/world", "Island"],
  ["/graphic-novels/", "Graphic Novels"],
  ["/forge", "Forge"],
  ["/arena", "Arena"],
  ["/market", "Exchange"],
  ["/discover", "Records"],
  ["/terminal", "Terminal"],
  ["/roadmap", "Roadmap"],
] as const;

export function SiteFrame() {
  const location = useLocation();
  useParallax(location.pathname);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
    if (location.hash) {
      window.requestAnimationFrame(() => document.querySelector(location.hash)?.scrollIntoView());
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="site-shell">
      <RouteSeo />
      <header className="site-header">
        <Link to="/" className="brand-lockup" aria-label="NUMGNUMS home">
          <img src="/art/brand/grinning-forge-emblem.webp" alt="" />
          <span>NUMGNUMS</span>
        </Link>
        <button className="menu-toggle" type="button" onClick={() => setMenuOpen(!menuOpen)} aria-expanded={menuOpen}>MENU</button>
        <nav className={menuOpen ? "is-open" : ""} aria-label="Main navigation">
          {navigation.map(([path, label]) => (
            <NavLink key={path} to={path}>{label}</NavLink>
          ))}
        </nav>
        <div className="header-actions">
          <Link to="/account" className="header-login">My hoard</Link>
        </div>
      </header>
      <main><Outlet /></main>
      <footer className="site-footer">
        <img src="/art/brand/grinning-forge-emblem.webp" alt="The grinning NUMGNUMS forge" />
        <div>
          <strong>NUMGNUMS</strong>
          <span>Forge responsibly. Nom irresponsibly.</span>
          <small>© 2026 NUMGNUMS</small>
        </div>
        <div className="footer-links">
          <Link to="/play">Play NUMGNUMS</Link>
          <Link to="/world">Forge Island</Link>
          <Link to="/graphic-novels/">Graphic Novels</Link>
          <Link to="/market">Exchange</Link>
          <Link to="/discover">World records</Link>
          <Link to="/terminal">Founder’s Terminal</Link>
          <Link to="/roadmap">Roadmap</Link>
          <Link to="/">The world beneath</Link>
          <Link to="/socials">Socials & community</Link>
          <Link to="/account">Player login</Link>
        </div>
      </footer>
    </div>
  );
}
